// utils/apiUtils.js
export const getApiBaseUrl = () => {
  if (typeof window === "undefined") return "http://localhost:8000/v1";
  
  const hostname = window.location.hostname;
  // Browser stack
  if (hostname.includes("bs-local")) {
    return "http://bs-local.com:8000/v1"
  }
  if (hostname.includes(".")) {
    // if hostname is an ip address, return the ip address with port 8000.
    // Use https so the auth token (sent as an Authorization header) is never
    // transmitted in cleartext. Plain http is only allowed for loopback/LAN dev.
    if (/^\d{1,3}(\.\d{1,3}){3}$/.test(hostname)) {
      const isLocalIp =
        hostname === "127.0.0.1" ||
        hostname.startsWith("10.") ||
        hostname.startsWith("192.168.") ||
        /^172\.(1[6-9]|2\d|3[01])\./.test(hostname);
      const scheme = isLocalIp ? "http" : "https";
      return `${scheme}://${hostname}:8000/v1`;
    }
    if (hostname.includes("app")) {
      return `https://${hostname.replace("app", "api")}/v1`;
    }
    return `https://api.${hostname}/v1`;
  }
  return "http://localhost:8000/v1";
};